// @ts-check
import { BaseMessage } from './BaseMessage';
import Text from 'components/base/Text';
import { contactCustomerSuccess } from 'common/services/contactCustomerSuccess.service';
import AppRouter from 'common/AppRouter';
import { useHistory } from 'react-router';
import BranchesIcon from 'images/icons-js/Branch.svg';
import styled from 'styled-components';
import { LBButton } from '@linearb/buzz';

const StyledReposCapLimitMessage = styled.div`
  & img[alt='git-logo'] {
    width: 3.5rem;
  }
`;

const ReposCapLimitMessage = props => {
  const { license, extra_data } = props;
  const history = useHistory();
  const isAlreadyInRepositoriesPage = !!history.location.pathname.includes(
    AppRouter.REPOSITORIES.path
  );
  const notificationMaxRepos = extra_data?.license_max_repos;
  const currMaxRepos = license?.maxRepos;

  if (notificationMaxRepos < currMaxRepos) return null;

  return (
    <StyledReposCapLimitMessage>
      <BaseMessage
        {...props}
        icon={BranchesIcon}
        title={`Monitoring ${notificationMaxRepos} repositories`}
        description={
          <Text color='radicalRed' size='large'>
            You've reached your plan's limit.
          </Text>
        }
        callToAction={[
          <div className='mr-2' key='edit'>
            <LBButton
              variant='outline'
              onClick={() =>
                isAlreadyInRepositoriesPage
                  ? null
                  : history.push(AppRouter.REPOSITORIES.path)
              }
            >
              Manage Repositories
            </LBButton>
          </div>,
          <LBButton
            key='support'
            variant='outline'
            onClick={contactCustomerSuccess}
          >
            Contact Customer Success
          </LBButton>
        ]}
      />
    </StyledReposCapLimitMessage>
  );
};

export default ReposCapLimitMessage;
